module.exports = __webpack_public_path__ + "static/media/Template.8976938d.csv";